/**
 * Zwei pflegbare Stämme, die mehrere Domänen brauchen: Kostenstellen (Auswahl je Beleg) und
 * Warengruppen (Zuordnung je Artikel/Maschine). Bewusst domänenneutral in einem eigenen Paket,
 * damit Admin, Finance, Stammdaten und Auswertung dieselben Typen nutzen.
 */

export type MasterKind = 'cost-center' | 'warengruppe';

/** Eintrag für Picker + Auswertung (nur aktive). */
export interface MasterEntry {
  readonly id: string;
  readonly code: string;
  readonly name: string;
  readonly active: boolean;
  readonly sortOrder: number;
}

/** Eintrag für die Admin-Pflege (inkl. inaktiver + Änderungsinfo). */
export interface AdminMasterEntry extends MasterEntry {
  readonly updatedAt: string;
  readonly updatedByName: string;
}

export interface SaveMasterEntryInput {
  readonly tenantId: string;
  /** null = neu anlegen. */
  readonly id: string | null;
  readonly code: string;
  readonly name: string;
  readonly active: boolean;
  readonly sortOrder: number;
}

export interface MastersGateway {
  /** Aktive Einträge -- für Picker (Beleg-Kostenstelle, Artikel-Warengruppe) und Auswertung. */
  listCostCenters(tenantId: string): Promise<readonly MasterEntry[]>;
  listWarengruppen(tenantId: string): Promise<readonly MasterEntry[]>;
  /** Alle Einträge inkl. inaktiver -- für die Admin-Pflege. */
  adminListCostCenters(tenantId: string): Promise<readonly AdminMasterEntry[]>;
  adminListWarengruppen(tenantId: string): Promise<readonly AdminMasterEntry[]>;
  saveCostCenter(input: SaveMasterEntryInput): Promise<void>;
  saveWarengruppe(input: SaveMasterEntryInput): Promise<void>;
  deleteCostCenter(tenantId: string, id: string): Promise<void>;
  deleteWarengruppe(tenantId: string, id: string): Promise<void>;
}

/** Validierung wie die DB-CHECKs (früher scheitern, klarere Meldung). */
export function normalizeMasterEntry(input: SaveMasterEntryInput): SaveMasterEntryInput {
  const code = input.code.trim();
  const name = input.name.trim();
  if (code.length < 1 || code.length > 20) throw new Error('Der Code muss 1–20 Zeichen haben.');
  if (name.length < 1 || name.length > 80) throw new Error('Der Name muss 1–80 Zeichen haben.');
  return {
    tenantId: input.tenantId,
    id: input.id,
    code,
    name,
    active: input.active,
    sortOrder: Number.isFinite(input.sortOrder) ? Math.trunc(input.sortOrder) : 0,
  };
}
